<template>
  <b-modal id="modal-password" title="Change Password" :ok-title="okTitle" :ok-only="success" @ok="changePassword" @show="resetModal">

  <div >
    <div v-if="!success">
      <b-form  @submit.prevent="changePassword">
        <b-form-group
          id="oldPassword-group"
          label="Current Password"
          label-for="oldPassword"
        >
          <b-form-input
            id="oldPassword"
            v-model="oldPassword"
            type="password"
            required
            placeholder="Old Password"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="newPassword-group"
          label="New Password"
          label-for="newPassword-input">
          <b-form-input
            id="newPassword-input"
            v-model="newPassword"
            type="password"
            required
            placeholder="New Password">
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="newPassword2-group"
          label="Confirm Password"
          label-for="newPassword2-input">
          <b-form-input
            id="newPassword2-input"
            v-model="newPassword2"
            type="password"
            required
            placeholder="New Password"
          >

          </b-form-input>
        </b-form-group>
      </b-form>
      <div>
      <b-alert :show="error" variant="danger">{{ errorMessage }}</b-alert>
      </div>
    </div>
    <div v-if="success">
      <b-alert :show="success" variant="success">{{ message }}</b-alert>

    </div>
  </div>
  </b-modal>
</template>

<script>
import http from '../http'

export default {
  name: 'change-password',

  data () {
    return {
      message: '',
      errorMessage: '',
      oldPassword: '',
      newPassword: '',
      newPassword2: '',
      error: false,
      success: false
    }
  },
  computed: {
    okTitle: function () { return this.success ? 'OK' : 'Change Password' }
  },
  methods: {
    changePassword (evt) {
      this.error = false
      if (!this.success) {
        evt.preventDefault()

        if (!(this.newPassword === this.newPassword2)) {
          console.log('passwords not matching')
          this.error = true
          this.errorMessage = 'The two password do not match'
        } else {
          http.post('/api/changePassword', {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword
          }).then((response) => {
            console.log('received msg ' + response.data.message)
            this.message = response.data.message
            this.success = true
          }).catch((err) => {
            console.log('error catched')
            if (err.response) {
              // Request made and server responded
              console.log(err.response.data)
              console.log(err.response.status)
              console.log(err.response.headers)
              this.error = true
              this.errorMessage = err.response.data.message
            } else if (err.request) {
              this.error = true
              this.errorMessage = 'Could not perform request'
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', err.message)
              this.error = true
              this.errorMessage = 'Could not perform request'
            }
          })
        }
      }
    },
    resetModal () {
      this.message = ''
      this.error = false
      this.success = false
      this.oldPassword = ''
      this.newPassword = ''
      this.newPassword2 = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue